<div
  [class]="typologies"
  class="tw-bg-white hb-group:tw-font-hello-type-next hb-group:tw-text-midnight-green"
>
  <router-outlet />
</div>
